const initialState = {
    isOpen: false,
    isActive: false,
};
const modalLogOutCourier = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_LOG_OUT_COURIER':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalLogOutCourier;
